<span *ngIf="warehouse"
  class="background-info"
  [matTooltip]="tooltip"
  [class.clickable-span]="isAvailableWarehouseChange"
  [class.disabled]="!isAvailableWarehouseChange"
  (click)="changeWarehouse()">
  {{ warehouse.name }}
</span>
